export default __webpack_public_path__ + "static/san-simon-a9f725b5c733881fef3956f3dced3988.png";